import React, { useState } from 'react'

import {
  Separator,
  IconCheckDefault,
  Button,
  IconAddDefault,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

import type { Competencies } from '../../types'
import classes from './SkillSection.module.scss'

export const SkillSection = (props: { competencies: Competencies[] }) => (
  <>
    <div className='d-block d-sm-none'>
      <SkillSectionResponsive ltSM {...props} />
    </div>
    <div className='d-none d-sm-block'>
      <SkillSectionResponsive ltSM={false} {...props} />
    </div>
  </>
)

const SkillSectionResponsive = ({
  competencies,
  ltSM,
}: {
  competencies: Competencies[]
  ltSM: boolean
}) => {
  const { t } = useTranslation('@mc/next')
  const [showMore, setShowMore] = useState(false)

  if (!competencies.length) return null

  return (
    <div className='mc-text--center mc-pt-9 mc-mt-12'>
      <div className='row justify-content-center'>
        <div className='col-12 col-lg-8'>
          <h2 className='mc-text-h1 mc-mb-9'>
            {t('sessions.skillSection.skillsYouWillLearn')}
          </h2>
        </div>
      </div>
      <div
        className={`row mc-mb-0 ${
          (!showMore && ltSM && classes.mobileShowLess) || ''
        }`}
      >
        {competencies.map((column) => (
          <div key={column.name} className='col-sm-4 col-xs-12 mc-text--left'>
            <h5 className='mc-text-h5'>{column.name}</h5>
            <Separator className='mc-opacity--muted mc-my-4' />
            <ul>
              {column.items.map((item) => (
                <li key={item} className='d-flex mc-mb-2'>
                  <IconCheckDefault
                    className={`${classes.checkmark} mc-mr-2 mc-mt-1`}
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {ltSM && !showMore && (
        <Button size='xs' kind='tertiary' onClick={() => setShowMore(true)}>
          <IconAddDefault size='sm' className='mc-mr-3' />
          {t('sessions.skillSection.showMore')}
        </Button>
      )}
    </div>
  )
}
